exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 53
// module chunks = 0 1 2